import { FC } from 'react';

import AgencyAdminBugoStatPage from '@service/bugo/page/AgencyAdminBugoStatPage';
import { Route, Routes } from 'react-router-dom';

export const BugoStatRouter: FC = () => {
  return (
    <Routes>
      <Route path="" element={<AgencyAdminBugoStatPage />} />
    </Routes>
  );
};
